var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62213 0C7.05077 0 4.96626 2.03766 4.96626 4.55123C4.96626 7.06481 7.05077 9.10246 9.62213 9.10246C12.1935 9.10246 14.278 7.06481 14.278 4.55123C14.278 2.03766 12.1935 0 9.62213 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62213 0C7.05077 0 4.96626 2.03766 4.96626 4.55123C4.96626 7.06481 7.05077 9.10246 9.62213 9.10246C12.1935 9.10246 14.278 7.06481 14.278 4.55123C14.278 2.03766 12.1935 0 9.62213 0Z",
    fill: "url(#paint0_linear_46_1488)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65587 11.5298C2.0845 11.5298 0 13.5674 0 16.081V17.5232C0 18.4374 0.67775 19.2168 1.60072 19.3641C6.91316 20.212 12.3311 20.212 17.6436 19.3641C18.5665 19.2168 19.2443 18.4374 19.2443 17.5232V16.081C19.2443 13.5674 17.1598 11.5298 14.5884 11.5298H14.1652C13.9361 11.5298 13.7085 11.5652 13.4908 11.6347L12.4162 11.9777C10.6006 12.5572 8.64362 12.5572 6.8281 11.9777L5.7535 11.6347C5.53576 11.5652 5.30814 11.5298 5.07908 11.5298H4.65587Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65587 11.5298C2.0845 11.5298 0 13.5674 0 16.081V17.5232C0 18.4374 0.67775 19.2168 1.60072 19.3641C6.91316 20.212 12.3311 20.212 17.6436 19.3641C18.5665 19.2168 19.2443 18.4374 19.2443 17.5232V16.081C19.2443 13.5674 17.1598 11.5298 14.5884 11.5298H14.1652C13.9361 11.5298 13.7085 11.5652 13.4908 11.6347L12.4162 11.9777C10.6006 12.5572 8.64362 12.5572 6.8281 11.9777L5.7535 11.6347C5.53576 11.5652 5.30814 11.5298 5.07908 11.5298H4.65587Z",
    fill: "url(#paint1_linear_46_1488)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1754 3.03415C20.6897 3.03415 21.1066 3.44169 21.1066 3.9444V6.06831H23.2794C23.7936 6.06831 24.2105 6.47584 24.2105 6.97856C24.2105 7.48127 23.7936 7.8888 23.2794 7.8888H21.1066V10.0127C21.1066 10.5154 20.6897 10.923 20.1754 10.923C19.6612 10.923 19.2443 10.5154 19.2443 10.0127V7.8888H17.0715C16.5573 7.8888 16.1404 7.48127 16.1404 6.97855C16.1404 6.47584 16.5573 6.06831 17.0715 6.06831H19.2443V3.9444C19.2443 3.44169 19.6612 3.03415 20.1754 3.03415Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1754 3.03415C20.6897 3.03415 21.1066 3.44169 21.1066 3.9444V6.06831H23.2794C23.7936 6.06831 24.2105 6.47584 24.2105 6.97856C24.2105 7.48127 23.7936 7.8888 23.2794 7.8888H21.1066V10.0127C21.1066 10.5154 20.6897 10.923 20.1754 10.923C19.6612 10.923 19.2443 10.5154 19.2443 10.0127V7.8888H17.0715C16.5573 7.8888 16.1404 7.48127 16.1404 6.97855C16.1404 6.47584 16.5573 6.06831 17.0715 6.06831H19.2443V3.9444C19.2443 3.44169 19.6612 3.03415 20.1754 3.03415Z",
    fill: "url(#paint2_linear_46_1488)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_1488",
    x1: 12.0749,
    y1: 2.31183,
    x2: 12.0749,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_1488",
    x1: 12.0749,
    y1: 2.31183,
    x2: 12.0749,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46_1488",
    x1: 12.0749,
    y1: 2.31183,
    x2: 12.0749,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/userAdd.b49689a0d127c692ff8e2a5583c1caea.svg";
export { ForwardRef as ReactComponent };